import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";


const JavaScriptLesson13 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

  <h3><strong>JavaScript Reserved Words</strong></h3>
   <p>Also known as <strong>keywords</strong>, reserved words in JavaScript programming language are those words which are exclusive to the programming language itself.</p>
   <p>They cannot be used in a variable or function name. They always mean something special to the program when called.</p>

  <div className="alert alert-secondary" role="alert">
  <ul class="list-group list-group-horizontal">
  <li class="list-group-item">await</li>
  <li class="list-group-item">break</li>
  <li class="list-group-item">catch</li>
  <li class="list-group-item">abstract</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">case</li>
  <li class="list-group-item">class</li>
  <li class="list-group-item">const</li>
  <li class="list-group-item">char</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">continue</li>
  <li class="list-group-item">debugger</li>
  <li class="list-group-item">default</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">delete</li>
  <li class="list-group-item">do</li>
  <li class="list-group-item">else</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">enum</li>
  <li class="list-group-item">export</li>
  <li class="list-group-item">extends</li>
  <li class="list-group-item">eval</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">false</li>
  <li class="list-group-item">float</li>
  <li class="list-group-item">finally</li>
  <li class="list-group-item">for</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">function</li>
  <li class="list-group-item">goto</li>
  <li class="list-group-item">if</li>
  <li class="list-group-item">implements</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">import</li>
  <li class="list-group-item">in</li>
  <li class="list-group-item">instanceof</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">interface</li>
  <li class="list-group-item">let</li>
  <li class="list-group-item">new</li>
  <li class="list-group-item">null</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">null</li>
  <li class="list-group-item">package</li>
  <li class="list-group-item">private</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">protected</li>
  <li class="list-group-item">public</li>
  <li class="list-group-item">return</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">super</li>
  <li class="list-group-item">switch</li>
  <li class="list-group-item">static</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">this</li>
  <li class="list-group-item">throw</li>
  <li class="list-group-item">throws</li>
  <li class="list-group-item">try</li>
</ul>
<ul class="list-group list-group-horizontal">
    <li class="list-group-item">transient</li>
  <li class="list-group-item">True</li>
  <li class="list-group-item">typeof</li>
  <li class="list-group-item">var</li>
</ul>
<ul class="list-group list-group-horizontal">
  <li class="list-group-item">void</li>
  <li class="list-group-item">while</li>
  <li class="list-group-item">with</li>
  <li class="list-group-item">yeild</li>
</ul>
</div>

<div className="alert alert-secondary" role="alert">
<h3><strong>Summary</strong></h3>
<ul class="list-group">
  <li class="list-group-item">Reserved words are also known as keywords</li>
  <li class="list-group-item">Reserved words are words that have special meaning in JavaScript</li>
</ul>
</div>






</div>


    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson13
